import React from "react"
import styles from "./partTitle.module.scss"

const PartTitle = React.memo(({ en, children }) => {
  return (
    <h3 className={styles.title}>
      <small>{en}</small> <br />
      {children}
    </h3>
  )
})

PartTitle.displayName = "PartTitle"
export default PartTitle
